import { Controller } from "@hotwired/stimulus"
import { apiGet } from "../shared/api"
import { escapeHtml, loadTranslations, t } from "../shared/utils"

export default class extends Controller {
  static targets = ["results", "pagination"]
  static values = { apiUrl: String }

  connect() {
    loadTranslations()
    this.page = 1
    this._fetchProfiles(1)
  }

  async _fetchProfiles(page) {
    const params = new URLSearchParams({ page })
    const data = await apiGet(`${this.apiUrlValue}?${params}`)
    if (!data) return

    this.page = data.meta.current_page
    this._renderProfiles(data.data)
    this._renderPagination(data.meta)
  }

  _renderProfiles(profiles) {
    if (!profiles.length) {
      this.resultsTarget.innerHTML = `
        <div class="text-center py-5">
          <i class="fa-solid fa-users fa-3x text-muted mb-3"></i>
          <h4>${t("index.no_profiles")}</h4>
          <p class="text-muted">${t("index.no_profiles_hint")}</p>
        </div>`
      return
    }

    this.resultsTarget.innerHTML = `<div class="row g-4">${profiles.map(u => this._profileCard(u)).join("")}</div>`
  }

  _profileCard(u) {
    const name = escapeHtml(u.full_name)
    const avatarHtml = u.avatar_url
      ? `<img src="${escapeHtml(u.avatar_url)}" alt="${name}" class="rounded-circle" style="width: 70px; height: 70px; object-fit: cover;">`
      : `<div class="d-inline-flex align-items-center justify-content-center rounded-circle bg-light" style="width: 70px; height: 70px;">
           <i class="fa-solid fa-2x ${u.sex === 1 ? "fa-mars text-primary" : "fa-venus text-danger"}"></i>
         </div>`

    const cityHtml = u.city
      ? `<p class="text-muted small mb-1"><i class="fa-solid fa-location-dot me-1"></i>${escapeHtml(u.city)}</p>`
      : ""
    const ageHtml = u.age
      ? `<p class="text-muted small mb-1">${u.age} ${t("dancer_profile.years_old")}</p>`
      : ""

    let classesHtml = ""
    if (u.dance_classes && (u.dance_classes.st || u.dance_classes.la)) {
      classesHtml = `<div class="d-flex justify-content-center gap-1 mb-1">`
      if (u.dance_classes.st) classesHtml += `<span class="badge bg-dm-navy small">ST: ${escapeHtml(u.dance_classes.st)}</span>`
      if (u.dance_classes.la) classesHtml += `<span class="badge bg-dm-navy small">LA: ${escapeHtml(u.dance_classes.la)}</span>`
      classesHtml += `</div>`
    }

    return `
      <div class="col-lg-3 col-md-4 col-sm-6 col-12">
        <a href="/profiles/${u.id}" class="card shadow-sm h-100 text-center text-decoration-none text-dark d-block">
          <div class="card-body py-4">
            <div class="mb-3">${avatarHtml}</div>
            <h6 class="mb-1">${name}</h6>
            ${cityHtml}${ageHtml}${classesHtml}
          </div>
        </a>
      </div>`
  }

  _renderPagination(meta) {
    if (meta.total_pages <= 1) {
      this.paginationTarget.innerHTML = ""
      return
    }

    const pages = []
    for (let i = 1; i <= meta.total_pages; i++) {
      const active = i === meta.current_page ? "active" : ""
      pages.push(`<li class="page-item ${active}"><a class="page-link" href="#" data-action="click->profiles#goToPage" data-page="${i}">${i}</a></li>`)
    }

    this.paginationTarget.innerHTML = `
      <div class="d-flex justify-content-center mt-4">
        <nav><ul class="pagination">${pages.join("")}</ul></nav>
      </div>`
  }

  goToPage(e) {
    e.preventDefault()
    const page = parseInt(e.currentTarget.dataset.page, 10)
    if (page && page !== this.page) {
      window.scrollTo({ top: 0, behavior: "smooth" })
      this._fetchProfiles(page)
    }
  }
}
